import React from "react";
import Header from "./Header";
import { Sidebar } from "./Sidebar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import { Box } from "@mui/material";
import { SidebarProvider, useColor, useSidebar, useTheme } from "../../common/hooks";

const LayoutContent = () => {
  const { colorBg } = useColor();
  const { isSidebarOpen } = useSidebar();
  const { currentTheme } = useTheme();

  React.useEffect(() => {
    // Update the CSS variable based on sidebar state
    document.documentElement.style.setProperty(
      "--sidebar-width",
      isSidebarOpen ? "200px" : "70px"
    );
  }, [isSidebarOpen]);

  React.useEffect(() => {
    const backgroundColor = colorBg || currentTheme?.palette?.background?.default || "var(--bg-page)";
    const textColor = currentTheme?.palette?.text?.primary || "var(--text-primary)";

    document.body.style.setProperty("background", backgroundColor, "important");
    document.body.style.setProperty("color", textColor, "important");
    document.body.style.setProperty("background-image", "none", "important");
  }, [colorBg, currentTheme]);

  return (
    <Box sx={{ minHeight: "100vh", position: "relative" }}>
      {/* Modern minimal background pattern */}
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          background: "var(--bg-page)",
          backgroundImage:
            currentTheme?.palette?.mode === "dark"
              ? "radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)"
              : "none",
          backgroundSize: "24px 24px",
          zIndex: -1,
          pointerEvents: "none",
        }}
      />

      <Header />
      <Sidebar />
      <Footer />
      <Outlet />
    </Box>
  );
};

const Layout = ({ children }) => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default Layout;
